import React, { useState } from 'react';
import FieldCustomisationComponent from '../../../components/fieldCustomisationComponent';
import InputField from '../../../../../../component/form/FormInput';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';

export default function PurchaseReceiveFieldCustomisation({
	isCreateForm,
	setCustomFieldForm,
	customFieldForm,
	customFieldError,
	setCustomFieldError,
}) {
	const [table, setTable] = useState([
		{
			field_name: 'Lorem Ipsom',
			data_type: 'Lorem Ipson',
			mandatory: 'Lorem Ipson',
			status: 1,
		},
		{
			field_name: 'Lorem Ipsom',
			data_type: 'Lorem Ipson',
			mandatory: 'Lorem Ipson',
			status: 1,
		},
		{
			field_name: 'Lorem Ipsom',
			data_type: 'Lorem Ipson',
			mandatory: 'Lorem Ipson',
			status: 1,
		},
	]);

	const dataTypeList = [
		{
			key: 'Text Box (Single-Line)',
			value: 'Text Box (Single-Line)',
		},
		{
			key: 'Email',
			value: 'Email',
		},
		{
			key: 'URL',
			value: 'URL',
		},
		{
			key: 'Phone',
			value: 'Phone',
		},
		{
			key: 'Number',
			value: 'Number',
		},
		{
			key: 'Decimal',
			value: 'Decimal',
		},
		{
			key: 'Amount',
			value: 'Amount',
		},
		{
			key: 'Percent',
			value: 'Percent',
		},
		{
			key: 'Date',
			value: 'Date',
		},
		{
			key: 'Date and Time',
			value: 'Date and Time',
		},
		{
			key: 'Check Box',
			value: 'Check Box',
		},
		{
			key: 'Auto-Generate Number',
			value: 'Auto-Generate Number',
		},
		{
			key: 'Dropdown',
			value: 'Dropdown',
		},
		{
			key: 'Multi-Select',
			value: 'Multi-Select',
		},
		{
			key: 'Lookup',
			value: 'Lookup',
		},
		{
			key: 'Text Box (Multi-Line)',
			value: 'Text Box (Multi-Line)',
		},
		{
			key: 'Attachment',
			value: 'Attachment',
		},
		{
			key: 'Image',
			value: 'Image',
		},
	];
	const handleFormData = (key, value) => {
		setCustomFieldForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};
	return (
		<div>
			{isCreateForm ? (
				<div className="p-3">
					<div className="d-flex align-items-center my-1">
						<div className="d-flex col-lg-2 col-3 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Label Name</div>
							<div className="fs-6 fw-light text-danger">*</div>
						</div>
						<div className="col-8 col-lg-3">
							<InputField
								label=""
								placeholder="Label Name"
								type="text"
								required={true}
								value={customFieldForm.label_name}
								onChange={(value) => handleFormData('label_name', value, true)}
								error={customFieldError?.label_name}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Data Type</div>
							<div className="fs-6 fw-light text-danger">*</div>
						</div>
						<div className="col-8 col-lg-3">
							<InputSelect
								options={dataTypeList}
								label=""
								placeholder="Select Data Type"
								error={customFieldError?.state_id}
								returnInputValue={false}
								value={customFieldForm.data_type}
								onChange={(value) => {}}
								onSelect={(options) => {
									handleFormData('data_type', options.value);
								}}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Is Mandatory</div>
						</div>
						<div className="col-8 col-lg-3">
							<div className="d-flex gap-4">
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={customFieldForm.is_mandatory}
										checked={customFieldForm.is_mandatory}
										id="mandatory_yes"
										name="mandatory"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('is_mandatory', value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="yes"
										className="fw-bold fs-5"
									>
										Yes
									</label>
								</div>
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={!customFieldForm.is_mandatory}
										checked={!customFieldForm.is_mandatory}
										id="mandatory_no"
										name="mandatory"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('is_mandatory', !value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="no"
										className="fw-bold fs-5"
									>
										No
									</label>
								</div>
							</div>
						</div>
					</div>
					<div className="d-flex align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Display in Portal</div>
						</div>
						<div className="col-8 col-lg-3">
							<div className="d-flex gap-4">
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={customFieldForm.status}
										checked={customFieldForm.status}
										id="status_yes"
										name="status"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('status', value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="yes"
										className="fw-bold fs-5"
									>
										Yes
									</label>
								</div>
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={!customFieldForm.status}
										checked={!customFieldForm.status}
										id="status_no"
										name="status"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('status', !value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="no"
										className="fw-bold fs-5"
									>
										No
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<FieldCustomisationComponent tableRows={table} />
			)}
		</div>
	);
}
